var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCityzenship(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 71,
    viewBox: "0 0 57 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2633 0.956299H6.73657C3.54253 0.956299 0.953247 3.554 0.953247 6.75843V64.2485C0.953247 67.4529 3.54253 70.0506 6.73657 70.0506H50.2633C53.4574 70.0506 56.0467 67.4529 56.0467 64.2485V6.75843C56.0467 3.554 53.4574 0.956299 50.2633 0.956299Z",
    stroke: "#7829FA",
    strokeWidth: 2.69,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4999 51.5108C37.3021 51.5108 44.4376 44.352 44.4376 35.5213C44.4376 26.6905 37.3021 19.5317 28.4999 19.5317C19.6978 19.5317 12.5623 26.6905 12.5623 35.5213C12.5623 44.352 19.6978 51.5108 28.4999 51.5108Z",
    stroke: "#02F3A2",
    strokeWidth: 2.69,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1979 31.044C13.1979 31.044 27.921 21.1825 43.7951 31.044",
    stroke: "#02F3A2",
    strokeWidth: 2.69,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1979 39.9065C13.1979 39.9065 27.921 49.768 43.7951 39.9065",
    stroke: "#02F3A2",
    strokeWidth: 2.69,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5623 35.5212H44.4306",
    stroke: "#02F3A2",
    strokeWidth: 2.69,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1078 50.8235C24.1078 50.8235 14.2783 36.0525 24.1078 20.1267",
    stroke: "#02F3A2",
    strokeWidth: 2.69,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9133 50.8235C32.9133 50.8235 42.7429 36.0525 32.9133 20.1267",
    stroke: "#02F3A2",
    strokeWidth: 2.69,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5424 51.4612V19.4893",
    stroke: "#02F3A2",
    strokeWidth: 2.69,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 71,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityzenship);
export default __webpack_public_path__ + "static/media/cityzenship.3661a62a18f4e35887728695a2436266.svg";
export { ForwardRef as ReactComponent };